import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch, FaHeart, FaBell, FaUsers, FaShieldAlt, FaGift, FaArrowRight, FaCheck } from 'react-icons/fa';
import './ComeFunzionaPage.css';

const ComeFunzionaPage = () => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      id: 0,
      title: "Cerca il prodotto",
      description: "Inserisci il nome del prodotto che stai cercando nella barra di ricerca",
      icon: FaSearch,
      color: "#c93249"
    },
    {
      id: 1,
      title: "Confronta le offerte",
      description: "Visualizza prezzi da migliaia di e-commerce e confronta le offerte",
      icon: FaUsers,
      color: "#10b981"
    },
    {
      id: 2,
      title: "Salva nella wishlist",
      description: "Aggiungi i prodotti che ti interessano alla tua wishlist personale",
      icon: FaHeart,
      color: "#e03a7e"
    },
    {
      id: 3,
      title: "Ricevi sconti",
      description: "Iscriviti per ricevere promozioni esclusive dagli e-commerce preferiti",
      icon: FaGift,
      color: "#f59e0b"
    }
  ];

  return (
    <main className="come-funziona-page">
      {/* Hero Section */}
      <section className="come-funziona-hero">
        <div className="main-content-container">
          <div className="come-funziona-hero-grid">
            <div className="come-funziona-hero-text">
              <h1 className="come-funziona-hero-title">
                Trova i migliori prezzi in un click
              </h1>
              <p className="come-funziona-hero-subtitle">
                Loverlist è il comparatore di prezzi che ti aiuta a risparmiare confrontando offerte da migliaia di e-commerce. 
                Cerca, confronta e acquista al miglior prezzo disponibile.
              </p>
              <div className="come-funziona-hero-cta">
                <Link to="/" className="come-funziona-cta-btn">
                  Inizia a cercare
                  <FaArrowRight />
                </Link>
              </div>
            </div>
            <div className="come-funziona-hero-image">
              <div className="come-funziona-hero-visual">
                <div className="search-mockup">
                  <div className="search-bar-mockup">
                    <FaSearch className="search-icon" />
                    <div className="search-input-mockup">
                      <div className="search-placeholder"></div>
                    </div>
                  </div>
                  <div className="search-results-mockup">
                    <div className="result-item">
                      <div className="result-image"></div>
                      <div className="result-info">
                        <div className="result-title"></div>
                        <div className="result-price"></div>
                      </div>
                    </div>
                    <div className="result-item">
                      <div className="result-image"></div>
                      <div className="result-info">
                        <div className="result-title"></div>
                        <div className="result-price"></div>
                      </div>
                    </div>
                    <div className="result-item">
                      <div className="result-image"></div>
                      <div className="result-info">
                        <div className="result-title"></div>
                        <div className="result-price"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="hero-stats">
                  <div className="stat-bubble">
                    <FaUsers />
                    <span>Migliaia di e-commerce</span>
                  </div>
                  <div className="stat-bubble">
                    <FaShieldAlt />
                    <span>Prezzi sempre aggiornati</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Come Funziona Section */}
      <section className="come-funziona-steps-section">
        <div className="main-content-container">
          <h2 className="come-funziona-steps-title">Come funziona in 4 semplici passi</h2>
          
          <div className="come-funziona-steps-grid">
            {steps.map((step, index) => (
              <div 
                key={step.id}
                className={`come-funziona-step ${activeStep === step.id ? 'active' : ''}`}
                onMouseEnter={() => setActiveStep(step.id)}
              >
                <div className="step-icon" style={{ color: step.color }}>
                  <step.icon />
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vantaggi Section */}
      <section className="come-funziona-benefits-section">
        <div className="main-content-container">
          <div className="come-funziona-benefits-grid">
            <div className="come-funziona-benefits-image">
              <div className="benefits-visual">
                <div className="wishlist-mockup">
                  <div className="wishlist-header">
                    <FaHeart className="wishlist-icon" />
                    <span>La tua Wishlist</span>
                  </div>
                  <div className="wishlist-items">
                    <div className="wishlist-item">
                      <div className="wishlist-item-image"></div>
                      <div className="wishlist-item-info">
                        <div className="wishlist-item-title"></div>
                        <div className="wishlist-item-price"></div>
                      </div>
                      <div className="wishlist-item-badge">-15%</div>
                    </div>
                    <div className="wishlist-item">
                      <div className="wishlist-item-image"></div>
                      <div className="wishlist-item-info">
                        <div className="wishlist-item-title"></div>
                        <div className="wishlist-item-price"></div>
                      </div>
                      <div className="wishlist-item-badge">-20%</div>
                    </div>
                    <div className="wishlist-item">
                      <div className="wishlist-item-image"></div>
                      <div className="wishlist-item-info">
                        <div className="wishlist-item-title"></div>
                        <div className="wishlist-item-price"></div>
                      </div>
                      <div className="wishlist-item-badge">-10%</div>
                    </div>
                  </div>
                </div>
                <div className="notification-bubble">
                  <FaBell />
                  <span>Nuovo sconto disponibile!</span>
                </div>
              </div>
            </div>
            <div className="come-funziona-benefits-text">
              <h2 className="come-funziona-benefits-title">
                Risparmia tempo e denaro
              </h2>
              <p className="come-funziona-benefits-description">
                Non perdere più tempo a navigare tra decine di siti web. Su Loverlist trovi tutto quello che cerchi in un unico posto, 
                con prezzi sempre aggiornati e offerte esclusive.
              </p>
              <div className="come-funziona-benefits-list">
                <div className="benefit-item">
                  <FaCheck />
                  <div>
                    <h4>Confronto immediato</h4>
                    <p>Vedi tutti i prezzi in una sola pagina</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <FaCheck />
                  <div>
                    <h4>Wishlist intelligente</h4>
                    <p>Salva i prodotti e ricevi notifiche sui prezzi</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <FaCheck />
                  <div>
                    <h4>Sconti esclusivi</h4>
                    <p>Accedi a promozioni riservate ai nostri utenti</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <FaCheck />
                  <div>
                    <h4>Prezzi sempre aggiornati</h4>
                    <p>I nostri algoritmi monitorano i prezzi 24/7</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* E-commerce Section */}
      <section className="come-funziona-ecommerce-section">
        <div className="main-content-container">
          <div className="come-funziona-ecommerce-grid">
            <div className="come-funziona-ecommerce-text">
              <h2 className="come-funziona-ecommerce-title">
                Migliaia di e-commerce a tua disposizione
              </h2>
              <p className="come-funziona-ecommerce-description">
                Collaboriamo con i migliori e-commerce italiani e internazionali per offrirti la più ampia selezione di prodotti 
                ai migliori prezzi disponibili sul mercato.
              </p>
              <div className="ecommerce-categories">
                <div className="category-tag">Elettronica</div>
                <div className="category-tag">Moda</div>
                <div className="category-tag">Casa</div>
                <div className="category-tag">Sport</div>
                <div className="category-tag">Libri</div>
                <div className="category-tag">Giochi</div>
                <div className="category-tag">Beauty</div>
                <div className="category-tag">Auto</div>
              </div>
              <div className="ecommerce-stats">
                <div className="ecommerce-stat">
                  <div className="stat-number">1000+</div>
                  <div className="stat-label">E-commerce</div>
                </div>
                <div className="ecommerce-stat">
                  <div className="stat-number">1M+</div>
                  <div className="stat-label">Prodotti</div>
                </div>
                <div className="ecommerce-stat">
                  <div className="stat-number">24/7</div>
                  <div className="stat-label">Aggiornamenti</div>
                </div>
              </div>
            </div>
            <div className="come-funziona-ecommerce-image">
              <div className="ecommerce-visual">
                <div className="ecommerce-logos">
                  <div className="logo-grid">
                    <div className="logo-item"></div>
                    <div className="logo-item"></div>
                    <div className="logo-item"></div>
                    <div className="logo-item"></div>
                    <div className="logo-item"></div>
                    <div className="logo-item"></div>
                    <div className="logo-item"></div>
                    <div className="logo-item"></div>
                  </div>
                </div>
                <div className="ecommerce-connection">
                  <div className="connection-line"></div>
                  <div className="connection-dot"></div>
                  <div className="connection-line"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="come-funziona-cta-section">
        <div className="main-content-container">
          <div className="come-funziona-cta-content">
            <h2 className="come-funziona-cta-title">
              Pronto a iniziare a risparmiare?
            </h2>
            <p className="come-funziona-cta-description">
              Unisciti a migliaia di utenti che già risparmiano con Loverlist
            </p>
            
            <div className="come-funziona-cta-buttons">
              <Link to="/" className="come-funziona-primary-btn">
                Inizia a cercare
              </Link>
              <Link to="/sign-up-customer" className="come-funziona-secondary-btn">
                Registrati gratis
              </Link>
            </div>

            <div className="come-funziona-cta-benefits">
              <div className="cta-benefit">
                <FaCheck />
                <span>Nessuna registrazione richiesta per cercare</span>
              </div>
              <div className="cta-benefit">
                <FaCheck />
                <span>Wishlist gratuita e illimitata</span>
              </div>
              <div className="cta-benefit">
                <FaCheck />
                <span>Sconti esclusivi per utenti registrati</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ComeFunzionaPage; 